module.exports = __webpack_public_path__ + "static/media/win.938be6ed.mp3";